import { render, staticRenderFns } from "./MatchPeriodScore.vue?vue&type=template&id=7205bc6d&scoped=true&"
import script from "./MatchPeriodScore.vue?vue&type=script&lang=js&"
export * from "./MatchPeriodScore.vue?vue&type=script&lang=js&"
import style0 from "./MatchPeriodScore.vue?vue&type=style&index=0&id=7205bc6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7205bc6d",
  null
  
)

export default component.exports